<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">To Tilly and Theresa, for being the first to read my book and encouraging me to continue the story.</p><br/>
<p style="text-indent:0em;">To Terri, for believing in me.</p><br/>
<p style="text-indent:0em;">To Isla, for having faith in me and for pushing me to get my story published.</p><br/>
<p style="text-indent:0em;">To Alf, for being a sounding board for all of my random ideas.</p><br/>
<p style="text-indent:0em;">And to Austin Macauley Publishers, for being the ones to trust that my writing was good enough to be out there in the world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?96122d84